<script setup lang="ts">
    import { cn } from '@/lib/utils';
    import { Label, type LabelProps } from 'reka-ui';
    import { computed, type HTMLAttributes } from 'vue';

    const props = defineProps<LabelProps & { class?: HTMLAttributes['class'] }>();

    const delegatedProps = computed(() => {
        const { class: _, ...delegated } = props;

        return delegated;
    });
</script>

<template>
    <Label
        data-slot="label"
        v-bind="delegatedProps"
        :class="
            cn(
                'flex items-center gap-2 text-xs leading-none font-medium select-none peer-disabled:cursor-not-allowed peer-disabled:opacity-50',
                props.class,
            )
        "
    >
        <slot />
    </Label>
</template>
